import { __decorate, __metadata } from 'tslib';
import * as i0 from '@angular/core';
import { booleanAttribute, Component, ViewEncapsulation, ChangeDetectionStrategy, Input } from '@angular/core';
import { CSSModifier, CSSComponent } from '@odx/angular/internal';
import { injectElement } from '@odx/angular/utils';

/**
 * Represents a button group component.
 */
let ButtonGroupComponent = class ButtonGroupComponent {
    constructor() {
        this.element = injectElement();
        /**
         * Specifies whether the buttons in the button group should be aligned to the right.
         *
         * @type {boolean}
         * @default false
         */
        this.alignRight = false;
        /**
         * Specifies whether the button group should be displayed as a block element.
         *
         * @type {boolean}
         * @default false
         */
        this.block = false;
        /**
         * Specifies whether the buttons should be displayed vertically.
         *
         * @type {boolean}
         * @default false
         */
        this.vertical = false;
        /**
         * Indicates whether the button group should be displayed in reverse order.
         *
         * @type {boolean}
         * @default false
         */
        this.reverse = false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ButtonGroupComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "16.1.0", version: "18.2.13", type: ButtonGroupComponent, isStandalone: true, selector: "odx-button-group", inputs: { alignRight: ["alignRight", "alignRight", booleanAttribute], block: ["block", "block", booleanAttribute], vertical: ["vertical", "vertical", booleanAttribute], reverse: ["reverse", "reverse", booleanAttribute] }, ngImport: i0, template: "<ng-content select=\"button[odxButton], a[odxButton]\" />\n", changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
};
__decorate([
    CSSModifier(),
    __metadata("design:type", Object)
], ButtonGroupComponent.prototype, "alignRight", void 0);
__decorate([
    CSSModifier(),
    __metadata("design:type", Object)
], ButtonGroupComponent.prototype, "block", void 0);
__decorate([
    CSSModifier(),
    __metadata("design:type", Object)
], ButtonGroupComponent.prototype, "vertical", void 0);
__decorate([
    CSSModifier(),
    __metadata("design:type", Object)
], ButtonGroupComponent.prototype, "reverse", void 0);
ButtonGroupComponent = __decorate([
    CSSComponent('button-group')
], ButtonGroupComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ButtonGroupComponent, decorators: [{
            type: Component,
            args: [{ standalone: true, selector: 'odx-button-group', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-content select=\"button[odxButton], a[odxButton]\" />\n" }]
        }], propDecorators: { alignRight: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], block: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], vertical: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], reverse: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }] } });

/**
 * Generated bundle index. Do not edit.
 */

export { ButtonGroupComponent };
